import React from 'react';
import { intl } from 'i18n';
import get from 'lodash/get';

import { COUNTRY_EDUCATOR_LABEL_MAP } from 'utils';
import messages from '../../displayMessages';

interface HeroContentHeadingProps {
  countryCode: string;
}

export const HeroContentHeading = ({
  countryCode,
}: HeroContentHeadingProps) => {
  const educatorLabel = get(
    COUNTRY_EDUCATOR_LABEL_MAP,
    countryCode,
    COUNTRY_EDUCATOR_LABEL_MAP.default
  );

  // Split the hero heading into words to highlight the last word
  const heroHeading = intl.formatMessage(
    messages.homeVariationPageHeroSectionHeading,
    { educatorLabel }
  );
  const words = heroHeading.split(' ');
  const lastWord = words.pop();
  const firstWords = words.join(' ');

  return (
    <>
      <h1 className='hero-content-heading'>
        {firstWords} <span className='highlight-word'>{lastWord}</span>
      </h1>
      <p className='hero-content-subheading'>
        {intl.formatMessage(messages.homeVariationPageHeroSectionText)}
      </p>
    </>
  );
};

export default HeroContentHeading;
